import { axiosPrivate } from "../api/axios";
import { useEffect } from "react";
import useRefreshToken from "./useRefreshToken";
import useAuth from "./useAuth";

const useAxiosPrivate = () => {
  const refresh = useRefreshToken();
  const { auth } = useAuth();

  useEffect(() => {
    const requestIntercept = axiosPrivate.interceptors.request.use(
      (config) => {
        if (!config.headers["Authorization"]) {
          config.headers["Authorization"] = `Bearer ${auth?.accessToken}`;
        }
        //console.log('Interceptor Request config header : ' + config.headers['Authorization']);
        return config;
      },
      (err) => {
        //console.log('Interceptor Request error : '  + JSON.stringify(err, null, 2));
        Promise.reject(err);
      },
    );

    const responseIntercept = axiosPrivate.interceptors.response.use(
      (response) => response,
      async (err) => {
        //console.log('Interceptor Response Config : ' + JSON.stringify(err.config, null, 2));
        //console.log('Interceptor Response : ' + JSON.stringify(err, null, 2));
        //console.log('Interceptor Response status : ' + JSON.stringify(err.response.status, null, 2));

        const prevRequest = err?.config;
        //console.log("Interceptor Response prevRequest : " +JSON.stringify(!prevRequest?.sent, null, 2),);
        if (err?.response?.status === 401 && !prevRequest?.sent) {
          prevRequest.sent = true;
          console.log("newAccessToken : before");
          const newAccessToken = await refresh();
          console.log("newAccessToken : after");
          prevRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          console.log("newAccessToken : " + newAccessToken);
          return axiosPrivate(prevRequest);
        }
        return Promise.reject(err);
      },
    );
    return () => {
      axiosPrivate.interceptors.request.eject(requestIntercept);
      axiosPrivate.interceptors.response.eject(responseIntercept);
    };
  }, [auth, refresh]);

  return axiosPrivate;
};

export default useAxiosPrivate;
